import React, { Component } from 'react';
import Select from 'react-select';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { array, func, bool, string, node } from 'prop-types';
import {
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import Loader from '../Loader/Loader';

class StatisticsFilter extends Component {
  static propTypes = {
    options: array.isRequired,
    onFilterChange: func.isRequired,
    onFilterApply: func.isRequired,
    onFilterChange: func.isRequired,
    id: string.isRequired,
    label: node.isRequired,
    name: string.isRequired,
    multiple: bool,
    placement: string,
    intl: intlShape.isRequired,
    deferLoad: bool,
    mobileModal: bool,
    loadOptions: func,
  };

  static defaultProps = {
    options: [],
    onFilterChange() {},
    onFilterApply() {},
    onFilterChange() {},
    multiple: false,
    mobileModal: false,
    placement: 'bottom',
    label: 'Button label',
  };

  state = {
    open: false,
    label: '',
    isLoaded: false,
  };

  componentDidMount() {
    this.updateLabel();
  }

  componentDidUpdate(_, prevState) {
    // загружаем фильтры один раз после открытия
    const { loadOptions, deferLoad } = this.props;
    const { isLoaded, open } = this.state;
    if (deferLoad && !isLoaded && open && open !== prevState.open) {
      Promise.resolve()
        .then(() => loadOptions())
        .then(() => {
          this.setState(() => ({
            isLoaded: true,
          }));
        })
        .catch(() => {
          this.setState(() => ({
            isLoaded: true,
          }));
        });
    }
  }

  toggle = () => {
    this.setState(prevState => ({ open: !prevState.open }));
  };

  applyFiltersHandler = () => {
    this.setState(() => ({ open: false }));
    this.props.onFilterApply();
    this.updateLabel();
  };

  clearFiltersHandler = name => {
    this.props.onFilterClear(name, this.updateLabel);
    this.setState(() => ({ open: false }));
  };

  updateLabel = () => {
    this.setState(() => ({ label: this.props.getLabel() }));
  };

  renderSelectPlaceholder = () => {
    const { intl } = this.props;
    return intl.formatMessage({
      id: 'main.select',
      defaultMessage: 'Select...',
    });
  };

  renderSelectNoResultsText = () => {
    const { intl } = this.props;
    return intl.formatMessage({
      id: 'statistics.filters.no-results-text',
      defaultMessage: 'No filters found',
    });
  };

  renderSelect = () => {
    const { options, onFilterChange, value, multiple, deferLoad } = this.props;
    const { isLoaded } = this.state;

    return !deferLoad || isLoaded ? (
      <Select
        options={options}
        onChange={onFilterChange}
        multi={multiple}
        value={value}
        placeholder={this.renderSelectPlaceholder()}
        noResultsText={this.renderSelectNoResultsText()}
        closeOnSelect={false}
        arrowRenderer={null}
        clearable={false}
        openOnFocus
        autoFocus
        alwaysOpened
      />
    ) : (
      <Loader isInner />
    );
  };

  render() {
    const { id, placement, name, mobileModal } = this.props;

    const { open, label } = this.state;

    const button = (
      <Button
        size="sm"
        color="light"
        active={open}
        id={id}
        outline
        className="statistics-filter-button btn-toggler"
      >
        {label}
        <i className="dropdown-toggle" />
        <span className="arrow" />
      </Button>
    );

    if (mobileModal) {
      return (
        <span className="statistics-filter-modal-trigger">
          <span onClick={this.toggle}>{button}</span>
          <Modal
            isOpen={open}
            toggle={this.toggle}
            centered
            autoFocus
            className="statistics-filter-modal"
          >
            <ModalHeader toggle={this.toggle}>{label}</ModalHeader>
            <ModalBody>{this.renderSelect()}</ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={this.applyFiltersHandler}>
                <FormattedMessage defaultMessage="Apply" id="statistics.filters.apply" />
              </Button>
              <Button color="secondary" onClick={() => this.clearFiltersHandler(name)}>
                <FormattedMessage defaultMessage="Clear" id="statistics.filters.clear" />
              </Button>
            </ModalFooter>
          </Modal>
        </span>
      );
    }

    return (
      <Dropdown isOpen={open} toggle={this.toggle} tag="span">
        <DropdownToggle
          data-toggle="dropdown"
          aria-expanded={open}
          tag="span"
        >
          {button}
        </DropdownToggle>
        <DropdownMenu placement={placement} className="filter-popover">
          {this.renderSelect()}
          <div className="filter-popover-controls">
            <Button size="sm" color="primary" onClick={this.applyFiltersHandler}>
              <FormattedMessage defaultMessage="Apply" id="statistics.filters.apply" />
            </Button>
            <Button size="sm" color="light" onClick={() => this.clearFiltersHandler(name)}>
              <FormattedMessage defaultMessage="Clear" id="statistics.filters.clear" />
            </Button>
          </div>
        </DropdownMenu>
      </Dropdown>
    );
  }
}

export default injectIntl(StatisticsFilter);
